export const parseCurrencyAmount = (value) => {
  if (!value) return null;
  const parsed = Number(String(value).replace(/[^0-9.-]/g, ''));
  return Number.isNaN(parsed) ? null : parsed;
};

export const buildBusinessDataFromOcr = (n) => ({
  ein: n.businessEin,
  naicsCode: n.naicsCode,
  censusTractNumber: n.censusTractNumber,
  businessOpened2Years: n.businessOpened2Years,
  minorityOwned: n.isMinorityOwned,
  womenOwned: n.isWomanOwned,
  severelyAffected: n.severelyAffected,
  numberOfFtes: n.numberOfFtes,
  numberOfEmployees: n.numberOfEmployees,
  numberOfJobs: n.numberOfJobs,
  annualRevenue: n.annualRevenue,
  addressLine1: n.businessAddressLine1,
  city: n.businessCity,
  county: n.businessCounty,
  countyCode: n.businessCountyCode,
  zipCode: n.businessZipcode,
});

export const buildSupportingDocuments = ({
  filesMap,
  additionalFilesList,
  ocrFileType,
  ocrFileSignedUrl,
  fundingProgram,
  applicationTemplateDocType,
}) => {
  const supportingDocuments = Object.entries(filesMap).map(([key, suggestedFile], i) => {
    const file = suggestedFile.file;
    return {
      fundingProgramDocumentId: Number(key),
      name: file?.name || `supportingDocument${i}`,
      fileType: suggestedFile.fileType,
      filePath: suggestedFile.filePath,
      documentType: 'applicationDocuments',
    };
  });

  const additionalDocuments = additionalFilesList.map((additionalFile, i) => {
    const file = additionalFile.file;
    return {
      displayName: additionalFile.name,
      name: file?.name || `Additional document ${i + 1}`,
      fileType: additionalFile.fileType,
      filePath: additionalFile.filePath,
      documentType: 'applicationDocuments',
    };
  });

  const combinedDocuments = [...supportingDocuments, ...additionalDocuments];

  if (ocrFileType && ocrFileSignedUrl) {
    const templateDocId = fundingProgram?.supportingDocuments?.find(
      (sd) => sd.documentType === applicationTemplateDocType
    )?.id;

    if (templateDocId) {
      combinedDocuments.push({
        documentType: 'applicationDocuments',
        fileType: ocrFileType,
        filePath: ocrFileSignedUrl,
        fundingProgramDocumentId: templateDocId,
      });
    }
  }

  return combinedDocuments;
};

export const partitionDraftSupportingDocuments = (
  supportingDocuments,
  fundingProgram,
  applicationTemplateDocType
) => {
  let filesMap = {};
  const additionalFilesList = [];

  for (const fileInfo of supportingDocuments || []) {
    const isApplicationTemplate = fundingProgram.supportingDocuments.find(
      (sd) =>
        sd.id === fileInfo.fundingProgramDocumentId &&
        sd.documentType === applicationTemplateDocType
    );

    if (isApplicationTemplate) {
      continue;
    }

    if (fileInfo.fundingProgramDocumentId) {
      filesMap = {
        ...filesMap,
        [fileInfo.fundingProgramDocumentId]: {
          name: fileInfo.name,
          fileType: fileInfo.fileType,
          filePath: fileInfo.filePath,
          documentType: fileInfo.documentType,
          uuid: fileInfo.uuid,
        },
      };
    } else {
      additionalFilesList.push(fileInfo);
    }
  }

  return { filesMap, additionalFilesList };
};

export const resolveFundingProgramWithDocuments = (fundingProgram, fundingPrograms = []) => {
  if (
    !fundingProgram ||
    (fundingProgram.supportingDocuments && fundingProgram.supportingDocuments.length > 0)
  ) {
    return fundingProgram;
  }

  const fullFundingProgram = fundingPrograms.find((fp) => fp.id === fundingProgram.id);
  return fullFundingProgram?.supportingDocuments ? fullFundingProgram : fundingProgram;
};
